const ROOTS = {
  AUTH: "/auth",
  WORKSPACE: "/workspace",
  DASHBOARD: "/dashboard",
} as const;

type ProjectId = string;
type WorkspaceId = string;
type IssueId = string;

const workspacePath = {
  select: "/select-workspace",
  payment: (workspaceId: WorkspaceId, planType: string) =>
    `${ROOTS.WORKSPACE}/${workspaceId}/payment/${planType}`,
  paymentSuccess: "/payment/success",
  paymentCancel: "/payment/cancel",
  projects: (workspaceId: WorkspaceId) =>
    `${ROOTS.WORKSPACE}/${workspaceId}/projects`,
  team: (workspaceId: WorkspaceId) => `${ROOTS.WORKSPACE}/${workspaceId}/team`,
  settings: (workspaceId: WorkspaceId) =>
    `${ROOTS.WORKSPACE}/${workspaceId}/settings`,
  billing: (workspaceId: WorkspaceId) =>
    `${ROOTS.WORKSPACE}/${workspaceId}/billing`,
  audit: (workspaceId: WorkspaceId) =>
    `${ROOTS.WORKSPACE}/${workspaceId}/audit`,
};

const dashboardPath = {
  // Remove the static forms path and only use the function version with workspaceId
  forms: (workspaceId: WorkspaceId) =>
    `${ROOTS.DASHBOARD}/${workspaceId}/forms`,
  formBuilder: (workspaceId: WorkspaceId) =>
    `${ROOTS.DASHBOARD}/${workspaceId}/forms/builder`,
  formSubmissions: (workspaceId: WorkspaceId, formId: string) =>
    `${ROOTS.DASHBOARD}/${workspaceId}/forms/${formId}/submissions`,
  templates: (workspaceId: WorkspaceId) =>
    `${ROOTS.DASHBOARD}/${workspaceId}/templates`,
  team: (workspaceId: WorkspaceId, projectId: ProjectId) =>
    `${ROOTS.DASHBOARD}/${workspaceId}/projects/${projectId}/team`,
};

export const paths = {
  auth: {
    login: `${ROOTS.AUTH}/login`,
    signup: `${ROOTS.AUTH}/signup`,
    verifyEmail: `${ROOTS.AUTH}/verify-email`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
    updatePassword: `${ROOTS.AUTH}/update-password`,
    onboarding: `/onboarding`,
  },
  blog: "/blogs",
  blogPost: (postId: string) => `/blogs/${postId}`,
  demo: "/demo",
  formDemo: "/form-demo",
  feedback: "/feedback",
  contact: "/contact",
  root: "/",
  invite: "/invite",
  termsOfService: "/terms",
  privacyPolicy: "/privacy",
  pricing: "/pricing",
  subscriptionSuccess: "/subscription/success",
  subscriptionCancel: "/subscription/cancel",
  workspace: {
    root: "/workspaces",
    new: `${ROOTS.WORKSPACE}/new`,
    ...workspacePath,
  },
  dashboard: {
    root: (workspaceId?: WorkspaceId) =>
      workspaceId ? `${ROOTS.DASHBOARD}/${workspaceId}` : ROOTS.DASHBOARD,
    create: `${ROOTS.DASHBOARD}/create-workspace`,
    notifications: `${ROOTS.DASHBOARD}/notifications`,
    auditLogs: `${ROOTS.DASHBOARD}/audit-logs`,
    ...dashboardPath,
  },
} as const;
